import {
  CHANGE_FILTER
} from '../constants/filter';

const initialState = {
  filters: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_FILTER:
      return {
        ...state,
        filters: action.data
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/filter.js